import { Component } from '@angular/core';

@Component({
  selector: 'logout-view',
  templateUrl: './logout.component.html'
})
export class LogoutViewComponent {
  public redirect(): void {
    window.location.href = window.location.origin;
  }
}
